import React from "react";
import { makeStyles } from "tss-react/mui";
import { Box, IconButton, Typography } from "@mui/material";
import { faqDataType } from "@/util/data/homeFaqData";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";
type props = {
  value: faqDataType;
  toggle: () => void;
  full?: boolean;
};
export default function FaqCard({ value, toggle, full }: props) {
  const { classes } = styles();
  return (
    <Box
      className={`${classes.card} ${
        value.active ? classes.cardActive : classes.cardNotActive
      }`}
      sx={{
        width: {
          xs: "90%", // Wider than 100% with padding/margins will overflow
          sm: full ? "100%" : "calc(50% - 12px)",
        },
        margin: {
          xs: "0 auto", // Center on mobile
          sm: 0, // No auto margin for larger screens (handled by parent)
        },
      }}
    >
      <Box className={`${classes.cardHead}`}>
        <Typography className={classes.headTxt}>{value.name}</Typography>
        <IconButton
          className={value.active ? classes.iconRotated : classes.iconDefault}
          onClick={() => toggle()}
        >
          <ExpandMoreIcon htmlColor={`${AppColors.text.default}`} />
        </IconButton>
      </Box>
      {value.active && (
        <Box className={`${classes.cardDet}`}>
          <Typography className={classes.descdet}>{value.detail}</Typography>
        </Box>
      )}
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {},
  card: {
    display: "flex",
    flexDirection: "column",
    borderRadius: pxToRem(8),
    padding: theme.spacing(2),
    justifyContent: "center",
    transition: "background 0.3s ease-in-out",
    border: `1px solid ${AppColors.neutral["65"]}`,
    "&:hover": {
      background: AppColors.primary["100"],
      cursor: "pointer",
    },
  },
  cardActive: {
    height: "auto",
  },
  cardNotActive: {
    height: pxToRem(65),
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
  },
  cardHead: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  cardDet: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  iconDefault: {
    transition: "transform 0.3s ease-in-out",
  },
  iconRotated: {
    transform: "rotate(180deg)",
    transition: "transform 0.3s ease-in-out",
  },
  descdet: {
    color: AppColors.text.second,
    fontWeight: 400,
    lineHeight: "160%",
    fontSize: pxToRem(16),
    textAlign: "justify",
    padding: theme.spacing(2),
  },
  headTxt: {
    fontWeight: 600,
    fontSize: pxToRem(16),
    color: "#323539",
    lineHeight: "160%",
    fontFamily: "General sans",
    letterSpacing: "0%",
  },
}));
